import { render, staticRenderFns } from "./InvoiceDetailsConfig.vue?vue&type=template&id=00323dff&scoped=true"
import script from "./InvoiceDetailsConfig.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00323dff",
  null
  
)

export default component.exports